import React, { FC } from 'react';

import Tooltip from 'components/Tooltip/Tooltip';
import { HelpIcon } from 'components/SvgIcons';
import getComponent from 'components/QuestionComponents';
import OrganizationQuestionDto from 'types/api/OrganizationQuestionDto';
import Markdown from 'components/Markdown/Markdown';

import './OrganizationQuestion.scss';

export interface OrganizationQuestionProps {
  question: OrganizationQuestionDto;
  disabled?: boolean;
}

const OrganizationQuestion: FC<OrganizationQuestionProps> = ({ question, disabled }) => {
  const QuestionComponent = getComponent(question.type);

  return (
    <div className="enkrateia-organization-question">
      <div className="question-label">
        <div>
          <Markdown>{question.question}</Markdown>
        </div>
        {question.help_text && (
          <Tooltip tooltip={question.help_text}>
            <HelpIcon color="#05445E" size={25} />
          </Tooltip>
        )}
      </div>
      <QuestionComponent questionValues={question.values} disabled={disabled} name={`questions.${question.id}.value`} />
    </div>
  );
};

export default OrganizationQuestion;
